// import './jquery.ztree.all-3.5'
let GdpVm = null;

const sendGdpThistoFormula = ( _this )=> {
  GdpVm = _this;
};
//引入gdpAccount.vue页面的vue实例
let ForVm = null;

const sendForThistoFormula = ( _this )=> {
  ForVm = _this;
};
//引入formula.vue页面的vue实例

// redirect 重定向 后加
import store from '../../../src/store/index'
var formulaGonshi = function () {
  this.config = {
    id: "panel",
    isPopWindow: false,
    isInitReset: true,
    isMultiBtn: true,
    isExcelBtn: false,
    isSelectReturnData: true,
    isReturnAllData: true,
    isValidateSelect: [0, 0, 0, 0],
    options: [{
        show: '指标',
        name: 'indicator',
        redirect: ''
      },
    ],
  };
};
formulaGonshi.prototype = {
  /**
   * 整个程序初始化的执行入口
   * @param {Object} customConfig
   */
  init: function (customConfig) {
    this.config = $.extend(this.config, customConfig || {});
  },
  /**
   * 弹出层居中显示
   */
  showLoadingStatus: function () {
    var mask = document.getElementById("selection-mask");
    var $main = $(".selection-main2");
    var top = $(document).scrollTop();
    var $win = $(window);
    var winH = $win.height(),
      h;
    if (winH < $main.height()) {
      h = 0;
    } else {
      h = (winH - $main.height()) / 2;
    }
    if (top > 0) {
      winH += top;
    }
    if (!-[1]) {
      mask.style.height = winH + "px";
    }
    $main.css({
      marginTop: h + "px"
    });
  },

  /**
   * 动态创建html
   * @param Object jsonList
   * {eventOk:function(){}}
   */
  outSideCreateHtml: function (jsonList) {
    var _self = this,
      _config = _self.config;
      // var handDesignBtn = document.getElementById("hand-design-btn");
      // var btnConfirm=document.createElement("input");
      // btnConfirm.type="button";
      // btnConfirm.value="确 定";
      // btnConfirm.className="selection-btn selection-btn-confirm";
      // btnConfirm.onclick=function(){
      //   if(_config.isPopWindow){
      //   //确认提交
      //     _self.successDialog(jsonList);
      //   } else {
      //     _self.success(jsonList);
      //   }
      // };
      // handDesignBtn.innerHTML = ''
      // handDesignBtn.appendChild(btnConfirm);
      if(ForVm){
        ForVm.boxVisible2 = true
        ForVm.boxVisible3 = true
        
        ForVm.$nextTick(()=>{
          var handDesignBtn = document.getElementById("hand-design-btn");
          var btnConfirm=document.createElement("input");
          btnConfirm.type="button";
          btnConfirm.value="保存公式";
          btnConfirm.className="selection-btn selection-btn-confirm";
          btnConfirm.onclick=function(){
            if(_config.isPopWindow){
            //确认提交
              _self.successDialog(jsonList);
            } else {
              _self.success(jsonList);
            }
          };
          handDesignBtn.innerHTML = ''
          handDesignBtn.appendChild(btnConfirm);
        })
      }
      if(GdpVm){
        GdpVm.boxVisible13 = true
        GdpVm.$refs.formula.maskShow = true
      }
      

      
      
    // if (_config.isInitReset && document.getElementById("selection-mask") != null) {
    //   $("#selection-mask").remove();
    // } else {
    //   if (document.getElementById("selection-mask") != null) {
    //     $("#selection-mask").css("top", $("body").scrollTop() + "px");
    //     $("#selection-mask").show();
    //     return;
    //   }
    // }
    // var mask = document.createElement("div");
    // if (jsonList.isMask) {
    //   mask.className = "selection-mask";
    //   mask.style.top = $("body").scrollTop() + "px";
    // }
    // mask.id = "selection-mask";
    // var main = document.createElement("div");
    // main.className = "selection-main2";
    // main.id = _config.id;
    // main.style.left='37%';
    // var head, options = _config.options;

    // var title = document.createElement("div");
    // title.className = "selection-title";
    // head = '<span>公式设置</span>';

    // title.innerHTML = head;
    // var closed = document.createElement("a");
    // closed.className = "selection-close";
    // closed.setAttribute("href", "javascript:;");
    // closed.innerHTML = "×";
    // closed.onclick = function () {
    //   //关闭事件
    //   _self.closed();
    // };
    // title.appendChild(closed);
    // main.appendChild(title);

    // var content = document.createElement("div");
    // content.className = "selection-content";
    // //左
    // var contentLeft = document.createElement("div");
    // contentLeft.className = "contentLeft";
    // var label = document.createElement("label");
    // label.innerHTML = '公式';
    // var textarea = document.createElement("textarea");
    // textarea.className = 'textareaCont';
    // textarea.placeholder='请输入';
    // //右
    // var contentRight = document.createElement("div");
    // contentRight.className = "contentRight";
    // var btnList = document.createElement("input");
    // btnList.className = 'btnList';
    // btnList.type = "button";
    // btnList.value = "按报表选取";
    // btnList.onclick = function () {
    //   vm.boxVisible3 = true;
    //   main.style.left='10%';
    // };
    // contentLeft.appendChild(label)
    // contentLeft.appendChild(textarea)
    // contentRight.appendChild(btnList)
    // content.appendChild(contentLeft)
    // content.appendChild(contentRight)

    // var handle = document.createElement("div");
    // handle.className = "selection-handle";
    // var btnConfirm = document.createElement("input");
    // btnConfirm.type = "button";
    // btnConfirm.value = "确 定";
    // btnConfirm.className = "selection-btn selection-btn-confirm";
    // btnConfirm.onclick = function () {
    //   if (_config.isPopWindow) {
    //     //确认提交
    //     _self.successDialog(jsonList);
    //   } else {
    //     _self.success(jsonList);
    //   }
    // };
    // var span = document.createElement("span");
    // var btnCancel = document.createElement("input");
    // btnCancel.type = "button";
    // btnCancel.value = "取 消";
    // btnCancel.className = "selection-btn selection-btn-cancel";
    // btnCancel.onclick = function () {
    //   _self.closed();
    // };
    // handle.appendChild(btnConfirm);
    // handle.appendChild(span);
    // handle.appendChild(btnCancel);
    // main.appendChild(content);
    // main.appendChild(handle);
    // mask.appendChild(main);
    // document.body.appendChild(mask);

    // //弹出层居中显示
    // _self.showLoadingStatus();

  },
  /**
   * 确认提交事件，当已选择的长度为0时，确认按钮显示灰色。大于0时，高度显示并绑定事件。
   */
  success: function (jsonList) {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config;
    var json = ForVm.gongshi
    $("div#" + _config.id).data(json);
    if (_config.isReturnAllData) {
      var warningMsg = json;
    }
    if (typeof jsonList.eventOk != 'undefined' & jsonList.eventOk instanceof Function) {
      var list = jsonList.eventOk(json);
    }
    _self.closed();
    ForVm.boxVisible2 = false
    ForVm.boxVisible3 = false
    GdpVm.$refs.formula.maskShow = false
    GdpVm.boxVisible13 = false
  },
  successDialog: function (jsonList) {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config;
    var json = _self.getSelectedCollection();
    var len = json.length;
    var arrID = [],
      arrName = [];
    var returnValue = [];
    for (var i = 0; i < len; i++) {
      arrID.push('\'' + json[i].id + '\'');
      arrName.push(json[i].name);
    }


    returnValue.push(arrID);
    returnValue.push(arrName);
    window.returnValue = returnValue;
    window.close();
    //document.getElementById(_config.selectedID).value=arrID.join(",");
    //document.getElementById(_config.outSideID).value=arrName.join(",");
    //用户自定义方法处理
    /*if(typeof jsonList.eventOk!='undefined'&jsonList.eventOk instanceof Function){
    	var list=jsonList.eventOk();
    }*/
  },
  /**
   * 关闭筛选事件
   */
  closed: function () {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config;
     // sid = _self.getSelectTabId();
    // if (_config.isPopWindow) {
    //   window.close();
    // } else {
    //   document.getElementById("selection-mask").style.display = "none";
    // }
  },
  //点击确定按钮 获取选择的参数列表
  getSelectedCollection: function () {
    var _self = this,
      _config = _self.config;
    var arr = [];
    for (var i = 0, len = _config.options.length, current, j; i < len; i++) {
      if (!_config.isReturnAllData && document.getElementById(_config.options[i].name).className.indexOf("active") == -1) { //没有选中 且为只填充选中tab的数据
        continue;
      }
      var vals = [],
        obj = {};
      if (_config.options[i].name != 'indExplain') {
        current = document.getElementById("selection-content-current-" + _config.options[i].name).getElementsByTagName("a");

        for (j = 0; j < current.length; j++) {
          var param = {};
          if (_config.options[i].name === 'indicator') {
            param.id = current[j].id;
            param.name = $(current[j]).text();
            param.unitid = current[j].getAttribute("unitid");
            param.unitname = $(current[j]).find(".unit").text().replace("(", "").replace(")", "");
          } else if (_config.options[i].name === 'group') {
            param.id = current[j].id.split('_')[1];
            param.name = $(current[j]).text();
            param.grouptypeid = current[j].id.split('_')[0];
          } else {
            param.id = current[j].id;
            param.name = $(current[j]).text();
          }
          vals.push(param);
        }
      } else {
        vals.push({
          name: $('#indExplain').find('textarea').val()
        })
      }
      obj["type"] = _config.options[i].name;
      obj["val"] = vals;
      if (!!_config.isExcelBtn) { //如果使用在excel里面 则添加特殊处理判断
        if ($("#horizontal-" + _config.options[i].name).hasClass("current")) {
          obj["orientation"] = "horizontal";
        } else if ($("#vertical-" + _config.options[i].name).hasClass("current")) {
          obj["orientation"] = "vertical";
        } else {
          obj["orientation"] = "";
        }
        if ($("#title-" + _config.options[i].name).length) {
          obj["title"] = $("#title-" + _config.options[i].name).hasClass("current") ? true : false;
        }
      }
      if (!!_config.isMultiBtn && !!$("#button-multi-" + _config.options[i].name).length) {
        obj["multi"] = $("#button-multi-" + _config.options[i].name).attr("multi") === 'false' ? false : true;
      }
      if (obj['multi']) { //叠加
        if ($('#superposition-' + _config.options[i].name).hasClass('current')) {
          obj["superposition"] = true;
        }
      }
      arr.push(obj);
    }
    return arr;
  },
};

/**
 * 按表样选指标，选中后父页面函数操作
 */

export {
  formulaGonshi,sendGdpThistoFormula,sendForThistoFormula
}


//////////////////
// WEBPACK FOOTER
// ./static/handsontable/js/Formula.js
// module id = 8P7m
// module chunks = 1